<template>
  <v-responsive class="overflow-y-auto" max-height="calc(80vh - 320px)">
    <v-data-table
      v-model="selectedStudent"
      :options.sync="studentTableOptions"
      :server-items-length="totalItems"
      :headers="headers"
      :items-per-page="5"
      :items="students"
      :footer-props="footerTable"
      loading-text="Đang Tải"
      show-select
      :loading="loading"
      disable-sort
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :items-per-page="5"
          :page-text="pageText"
          :pagination="pagination"
          :options="options"
          :items-per-page-options="totalItems > 100 ? [5, 10, 15] : [5, 10, 15, -1]"
          @update:options="updateOptions"
          items-per-page-text="Học sinh mỗi trang"
          items-per-page-all-text="Tất cả"
        />
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <card-student-name :student="item" link />
      </template>
      <template v-slot:[`item.dob`]="{ item }">
        <span>{{ item.dob | ddmmyyyy }}</span>
      </template>
      <template v-slot:[`item.currentClass`]="{ item }">
        <router-link style="text-decoration: none" :to="'/class/' + (item.currentClass && item.currentClass.id)">
          <span v-if="item.currentClass">{{ item.currentClass | getCurrentClass }}</span>
        </router-link>
      </template>
      <template v-slot:[`item.senderMethod`]="{ item }">
        <div class="d-flex align-center">
          {{ item | getNotificationMethod }}
          <div v-if="hasMobileToken(item)">
            <v-tooltip max-width="250px" bottom>
              <template v-slot:activator="{ on, attrs }">
                <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px">
                  <v-icon color="success">mdi-check</v-icon>
                </div>
              </template>
              <span>Đã đăng nhập</span>
            </v-tooltip>
          </div>
        </div>
      </template>
      <template v-slot:[`item.phone`]="{ item }">
        <v-tooltip max-width="250px" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-bind="attrs" v-on="on" class="d-inline-block text-truncate" style="max-width: 150px">
              {{ item | getContactBookPhones }}
            </div>
          </template>
          <span>{{ item | getContactBookPhones }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-responsive>
</template>

<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapState, mapActions, mapMutations } from 'vuex'

const originHeaders = [
  { text: 'Học sinh', value: 'name', width: '35%' },
  { text: 'Ngày sinh', value: 'dob', width: '15%' },
  { text: 'Lớp', value: 'currentClass', width: '10%' },
  { text: 'Hình thức sử dụng', value: 'senderMethod', width: '20%' },
  { text: 'SĐT đăng ký', value: 'phone', width: '30%' }
]

export default {
  data() {
    return {
      headers: this.propHeaders && this.propHeaders.length ? this.propHeaders : originHeaders,
      originHeaders: originHeaders,
      studentTableOptions: {},
      selectedStudent: []
    }
  },

  components: {
    CardStudentName
  },
  computed: {
    ...mapState('students', ['totalItems', 'students', 'pageText', 'loading', 'studentSearchParams']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học sinh mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions('students', ['requestPageSettings', 'searchStudents']),
    ...mapMutations('tuitionFeeGroupStudent', ['setSelectedStudent']),
    async refresh(query) {
      await this.searchStudents({ ...query })
    },
    clearSelected() {
      this.selectedStudent = []
    },
    hasMobileToken(item) {
      if (item.contactBook && item.contactBook.isApp && (item.fcmAndroid || item.fcmIos)) {
        let tokens = []
        if (item.fcmAndroid) {
          const androidTokens = item.fcmAndroid.split(';')
          androidTokens.map(token => {
            if (token) tokens.push(token)
          })
        }
        if (item.fcmIos) {
          const iosTokens = item.fcmIos.split(';')
          iosTokens.map(token => {
            if (token) tokens.push(token)
          })
        }

        tokens = [...new Set(tokens)]
        return tokens.length > 0
      }

      return false
    }
  },
  async created() {
    await this.refresh({ ...this.filter })
  },
  filters: {
    getClassCount(classes) {
      return classes ? classes.length : 0
    },
    getClasses(classes) {
      if (classes && classes.length > 0) {
        return classes.map(c => c.title).join(' ,')
      } else return ''
    },
    getCurrentClass(currentClass) {
      return currentClass == null ? '' : currentClass.title
    }
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    },
    selectedStudent: {
      handler() {
        this.setSelectedStudent(this.selectedStudent)
      }
    }
  }
}
</script>

<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}
</style>
